import { FAQS } from '../../data/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

export default function FAQ() {
  return (
    <section className="py-24 lg:py-36 bg-ivory">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4 reveal">
          <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep mb-6">Frequently Asked</p>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.05] text-charcoal">
            Considered <em className="italic-accent">answers.</em>
          </h2>
          <p className="mt-6 text-charcoal/70 leading-relaxed">
            Still curious? A short WhatsApp to the studio gets you a faster answer than a long form.
          </p>
        </div>
        <div className="lg:col-span-8 reveal">
          <Accordion type="single" collapsible className="border-t border-charcoal/10">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-charcoal/10">
                <AccordionTrigger className="font-serif text-lg md:text-2xl text-left py-6 hover:no-underline hover:text-champagne-deep text-charcoal">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-charcoal/70 text-base leading-relaxed pb-6 max-w-3xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
